import {
  Alert,
  Box,
  Button,
  Icon,
  Icons,
  LinearProgress,
  Stack,
  styled,
} from '@nextiva/next-ui-components';
import React, { FC, useContext } from 'react';
import { actionTypes, RootContext } from 'RootContext/rootContext';

const StyledAlertCloseIcon = styled(Icon)`
  cursor: default;
  color: white;
`;

const StyledAlertInProgressMessage = styled(Box)`
  width: 280px;
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
  font-weight: 400;
`;

const StyledAlertInProgress = styled(Alert)`
  width: 452px;
  margin: 8px auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 15%;
  z-index: 9999;
  color: white;
  background-color: ${({ theme }) => theme.palette.blueGrey[900]};
  .MuiAlert-icon {
    color: white;
  }
  .MuiAlert-message {
    flex-grow: 1;
  }
`;

export const ActionButton = styled(Button)`
  padding: 1px 10px !important;
  &.MuiButton-text.MuiButton-textPrimary {
    color: ${({ theme }) => theme.palette.lightBlue[400]};
  }
`;

export type AttachmentsFileUploadProps = {
  message: string;
  onAction: () => void;
  onClose?: () => void;
};

export const AttachmentsError: FC<AttachmentsFileUploadProps> = ({
  message,
  onAction,
}) => {
  const { rootDispatch } = useContext(RootContext);

  const closeSnackbar = () => {
    rootDispatch({
      type: actionTypes.CLOSE_GLOBAL_SNACKBAR,
    });
  };
  return (
    <StyledAlertInProgress icon={<Icon icon={Icons.remove} />}>
      <Stack
        direction="row"
        flex={1}
        width="100%"
        spacing={1}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Stack flex={1}>
          <StyledAlertInProgressMessage>
            <Box sx={{ color: '#FF6655' }} component="span">
              Upload failed
            </Box>
            {'  '}
            {message}
          </StyledAlertInProgressMessage>
        </Stack>
        <ActionButton
          data-testid="PlatformAdminUI-Snackbar-View"
          variant="text"
          color="primary"
          onClick={() => {
            if (onAction) onAction();
            closeSnackbar();
          }}
        >
          Retry
        </ActionButton>
        <StyledAlertCloseIcon
          data-testid="PlatformAdminUI-Snackbar-View"
          icon={Icons.close}
          onClick={closeSnackbar}
        />
      </Stack>
    </StyledAlertInProgress>
  );
};

export const AttachmentsSuccess: FC<AttachmentsFileUploadProps> = ({
  message,
  onAction,
}) => {
  const { rootDispatch } = useContext(RootContext);

  const closeSnackbar = () => {
    rootDispatch({
      type: actionTypes.CLOSE_GLOBAL_SNACKBAR,
    });
  };

  return (
    <StyledAlertInProgress icon={<Icon icon={Icons.checkCircle} />}>
      <Stack
        direction="row"
        flex={1}
        width="100%"
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <StyledAlertInProgressMessage>{message}</StyledAlertInProgressMessage>
        <ActionButton
          data-testid="PlatformAdminUI-Snackbar-View"
          variant="text"
          color="primary"
          onClick={() => {
            if (onAction) onAction();
            closeSnackbar();
          }}
        >
          View
        </ActionButton>
        <StyledAlertCloseIcon
          data-testid="PlatformAdminUI-Snackbar-View"
          icon={Icons.close}
          onClick={closeSnackbar}
        />
      </Stack>
    </StyledAlertInProgress>
  );
};

export const AttachmentsInProgress: FC<AttachmentsFileUploadProps> = ({
  message,
  onAction,
}) => {
  const { rootDispatch } = useContext(RootContext);

  const closeSnackbar = () => {
    rootDispatch({
      type: actionTypes.CLOSE_GLOBAL_SNACKBAR,
    });
  };

  return (
    <StyledAlertInProgress icon={<Icon icon={Icons.upload} />}>
      <Stack
        direction="row"
        flex={1}
        width="100%"
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Stack flex={1}>
          <StyledAlertInProgressMessage>{message}</StyledAlertInProgressMessage>
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        </Stack>
        <ActionButton
          data-testid="PlatformAdminUI-Snackbar-Cancel"
          variant="text"
          color="primary"
          onClick={() => {
            if (onAction) onAction();
            closeSnackbar();
          }}
        >
          Cancel
        </ActionButton>
        <StyledAlertCloseIcon
          data-testid="PlatformAdminUI-Snackbar-View"
          icon={Icons.close}
          onClick={closeSnackbar}
        />
      </Stack>
    </StyledAlertInProgress>
  );
};
